module.exports = __webpack_public_path__ + "static/media/3DTeamStatistics.a91775a4.png";